import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useBehaviorData } from '@hooks';
// import { logError } from '@log';
import { setDelayPackageId, updateSelectedDhgateItems } from '@store';
import { ClaimType } from '@constants';

export const useChooseItems = () => {
  const {
    fulfilledItems,
    unFulfilledItems, orderName, delayPackageId, type, selectedDhgateItems,
  } = useSelector((state) => state.claim);
  const [open, setOpen] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);
  const [reason, setReason] = useState({});
  const [willChecked, setWillChecked] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const setReportData = useBehaviorData();

  // const [isLoading, setIsLoading] = useState(false);
  // const { getReviewData } = useReviewData();
  const { platform } = useSelector((state) => state.policy);

  const onChange = (value, info) => {
    if (value) {
      dispatch(updateSelectedDhgateItems({ selectType: 'add', info: { quantity: value }, currentItem: info }));
    } else {
      dispatch(updateSelectedDhgateItems({ selectType: 'delete', currentItem: info }));
    }
  };
  const handleCheckboxChange = (event, info) => {
    const { checked, value } = event.target;
    if (checked) {
      updateSelectedDhgateItems({ quantity: value, info });
    }
  };

  const onClickTitle = (item) => {
    dispatch(setDelayPackageId(item.fulfilledId));
  };

  const onClickContinue = async () => {
    setReportData({ chooseItemsTime: `${Date.now()}`, issueType: type });

    if ([ClaimType.Loss, ClaimType.Theft].includes(type)) {
      navigate('../upload');
    } else {
      navigate('../payment');
    }
  };

  const onClickBack = () => {
    dispatch(setDelayPackageId(''));
  };

  const handleOK = (info) => {
    setOpen(false);
    dispatch(updateSelectedDhgateItems({ selectType: 'add', info, currentItem: willChecked }));
  };

  // lineItem 勾选change
  const handleChange = (event, item) => {
    const { checked, value } = event.target || {};
    if (!checked) {
      dispatch(updateSelectedDhgateItems({ selectType: 'delete', currentItem: willChecked }));
    } else if (value) {
      setOpen(true);
      // setReason({ reason: item.reason, comment: item.comment, files: item.attachments });
      setWillChecked(item);
    } else {
      // dispatch(addSelectedItems(value));
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  // reason-dialog edit click
  const handleItemEdit = (item) => {
    setWillChecked(item);
    setOpen(true);
    setReason({ reason: item.reason, comment: item.comment, files: item.attachments });
  };

  const clearItems = () => {
    // dispatch(clearSelectedItems());
  };
  return {
    fulfilledItems,
    unFulfilledItems,
    isBtnDisable: !Object.keys(selectedDhgateItems).length,
    delayPackageId,
    orderName,
    open,
    willChecked,
    reason,
    selectedDhgateItems,
    // isLoading,
    handleOK,
    handleItemEdit,
    clearItems,
    handleChange,
    handleClose,
    platform,
    onChange,
    handleCheckboxChange,
    onClickTitle,
    onClickContinue,
    onClickBack,
  };
};
